
import { WPElement } from "@wordpress/element";
import cx from "classnames";

export function IconButton( props: {
	as: string,
	variant?: "primary" | "secondary" | "white" | "transparent",
	size?: "xs" | "sm" | "md" | "lg" | "xl" | "none",
	icon: WPElement,
	onClick?: Function,
	className: string
} ) {
	let Tag = "button" as keyof JSX.IntrinsicElements;
	if ( props.as && props.as != "button" ) {
		Tag = props.as as keyof JSX.IntrinsicElements;
	}

	const icon = props.icon;

	let css, cssSize;

	const size = props.size ? props.size : "md";
	if ( size == "xs" ) {
		cssSize = "text-lg w-7 h-7";
	} else if ( size == "sm" ) {
		cssSize = "text-xl w-8 h-8";
	} else if ( size == "md" ) {
		cssSize = "text-2xl w-9 h-9";
	} else if ( size == "lg" ) {
		cssSize = "text-3xl w-10 h-10";
	} else if ( size == "xl" ) {
		cssSize = "text-4xl w-11 h-11";
	}

	if ( props.variant == "primary" ) {
		css = cx(
			"text-white bg-gradient-to-r from-primary-700 to-primary-500",
			"hover:from-primary-500 hover:to-primary-700 active:bg-primary-600",
			"focus:outline-none",
			"active:bg-gradient-to-r active:from-primary-700 active:to-primary-700"
		);
	} else if ( props.variant == "secondary" ) {
		css = cx(
			"text-white bg-ui-900 border-ui-900 hover:bg-ui-700 active:bg-ui-900 focus:outline-none"
		);
	} else if ( props.variant == "white" ) {
		css = cx(
			"text-ui-700 bg-white border border-neutral-200 hover:border-neutral-300 active:border-neutral-100 active:bg-neutral-100 focus:outline-none"
		);
	} else if ( props.variant == "transparent" ) {
		css = cx(
			"text-ui-700 hover:bg-ui-100 active:bg-ui-300"
		);
	}

	return (
		<Tag onClick={ props.onClick } className={ cx(
			"flex items-center justify-center rounded-full transition duration-300 hover:ease-in-out focus:outline-none",
			"focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ui-primary",
			props.className,
			css, cssSize
		) }>{ icon }</Tag>
	)
}
